export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "Você não tem créditos de IA suficientes para gerar este relatório. Entre em contato com o administrador.",
      REPORT_ACCESS_DENIED: "Este relatório de IA não está habilitado para sua conta.",
      NOT_FOUND: "Não foi possível encontrar o relatório solicitado.",
      INVALID_INPUT: "Alguns dos dados fornecidos são inválidos. Revise-os e tente novamente.",
      INVALID_GEOMETRY: "A área selecionada não é válida. Ajuste a geocerca e tente novamente.",
    },
    usersByStatus: "Usuários por Status",
    usersByGender: "Usuários por Gênero",
    avgAreaPerUnit: "Área Média em {unit}",
    yieldPerUnit: "Rendimento por {unit}",
    listByYield: "Lista por Rendimento",
    gen: "Gênero",
    gender: "Gráfico de Gênero",
    unspefied: "Não Especificado",
    byCountry: "Por País",
    avgPriceFarmer: "Preço Médio Pago por Agricultor (Cacau)",
    avgPrice: "Preço Médio",
    selectYear: "Selecionar Ano",
    total: "Total",
    today: "Hoje",
    week: "Semana",
    month: "Mês",
    year: "Ano",
    all: "Todos",
    selectCrop: "Selecionar Cultura",
    selectRegion: "Selecionar Região",
    selectProvinceState: "Selecionar Província/Estado",
    downloadPdfReport: "Baixar Relatório em PDF",
    export: "Exportar",
    search: "Pesquisar",
    yield: "Rendimento",
    averageSellingPriceByAllFarmers:
      "Preço Médio de Venda por Todos os Agricultores",
    averageSellingPricePerFarmer: "Preço Médio de Venda por Agricultor",
    pricePaid: "Preço Pago",
    dashboard: {
      topCharts: "Principais Gráficos",
      regions: "Regiões",
      noOfFarms: "Número de Fazendas/Região",
      provinces: "Províncias/Estados",
      landArea: "Área de Terreno",
      avgFarmerLand: "Terreno Médio por Agricultor",
      viewAll: "Ver Todos",
      crops: "Culturas",
      plantedAreaCrop: "Área Plantada/Cultura",
      plantedArea: "Área Plantada",
      avgYieldCrop: "Rendimento Médio/Cultura",
      averageYield: "Rendimento Médio",
      yieldChart: "Gráfico de Rendimento",
      selectFarm: "Selecionar Fazenda",
      soilQuality: "Qualidade do Solo",
      pests: "Pragas",
      occurrences: "Ocorrências",
      equipments: "Equipamentos",
      goalAchievedChart: "Gráfico de Metas Alcançadas",
      soilValues: "Valores do Solo",
      soil: "Solo",
      showReport: "Mostrar relatórios no Painel",
      selectAll: "Selecionar Tudo",
    },
    weight: "Peso",
    quality: "Qualidade",
    price: "Preço",

    male: "Masculino",
    female: "Femenino",
    other: "Outros",
    farmerName: "Nome do agricultor",
    farmerProdChart: "Gráfico de Produção do Agricultor",
    production: "Produção",
    byProduction: "Por Produção",
    byName: "Por nome",
    descending: "Decrescente",
    ascending: "Crescente",
    buyingStationProdChart: "Gráfico de Produção da Estação de Coleta",
    buyingStation: "Estação de coleta",
    buyingStationName: "Nome da estação de coleta",
    dryMilling: "Moagem a Seco",
    dryMillingName: "Nome de moagem a seco",
    dryMillingProdChart: "Tabela de Produção de Moagem a Seco",
    view: "Visualizar",
    date: "Encontro",
    reports: "Relatórios",
    pests: {
      pestReport: "Relatório de Pragas",
      filterByCrops: "Filtrar por Culturas",
      pestStatistics: "Estatísticas de Pragas",
      regions: "Regiões",
      occurrences: "Ocorrências",
      pestChart: "Gráfico de Pragas",
      totalArea: "Área Total",
      pestName: "Nome da Praga",
      region: "Região",
      crop: "Culturas",
      listByLand: "Listar por Terreno",
    },
    regions: {
      regionalReport: "Relatório Regional",
      listByFarm: "Lista por Fazenda",
      listByFarmers: "Lista por Agricultores",
      listByYield: "Lista por Rendimento",
      regionalStatistics: "Estatísticas Regionais",
      countries: "Países",
      states: "Estados/Províncias",
      city: "Cidade/Vila",
      farmsIn: "Fazendas em",
      regionalChart: "Gráfico Regional",
      farms: "Fazendas",
      regionName: "Nome da Região",
      farmers: "Agricultores",
      yield: "Rendimento/Acre",
    },

    yieldPrediction: "Previsão de Rendimento",
    listOfReports: "Lista de Relatórios",
    noYieldPredictionReportsFound: "Nenhum relatório de previsão de rendimento encontrado",
    loadingYieldPredictions: "Carregando previsões de rendimento...",
    createNewReport: "Criar Novo Relatório",

    howToUseReport: "Como usar o relatório?",
    viewGuide: "Ver guia",
    cancel: "Cancelar",
    generateReport: "Gerar Relatório",
    selectFarmGeofence: "Selecionar Geocerca da Fazenda",
    selectFarmGeofenceDescription: "Selecione uma fazenda registrada, desenhe o limite da sua fazenda no mapa ou insira uma localização para começar a analisar a previsão de rendimento da área da fazenda.",
    point: "Ponto",
    geofence: "Geocerca",
    selectFarmZone: "Selecionar Fazenda/Zona",
    select: "Selecionar",
    latitude: "Latitude",
    longitude: "Longitude",
    uploadGeojsonFile: "Carregar Arquivo GeoJSON",
    uploadGeojsonFileDescription: "Selecione um arquivo GeoJSON com sua geocerca do seu computador e carregue-o. Apenas uma geocerca será carregada por vez, mesmo que seu arquivo tenha várias geocercas.",
    selectAFile: "Selecionar Um Arquivo",
    hideAdvanced: "Ocultar Avançado",
    showAdvancedVariation: "Mostrar Variação Avançada",
    uploadHistoricalYieldDataDescription: "Por favor, carregue os dados históricos de rendimento da sua fazenda",
    showInstructions: "Mostrar Instruções",
    downloadTemplate: "Baixar Modelo",
    chooseFile: "Escolher Arquivo",
    noFileSelected: "Nenhum arquivo selecionado",
    yieldPredictionGuide: "Guia de Previsão de Rendimento",
    forecastedYields: "Rendimentos Previstos",
    farmArea: "Área da Fazenda",
    yieldForecasts: "Previsões de Rendimento",
    graph: "Gráfico",
    actualYields: "Rendimentos Reais",
    predictedFutureYields: "Rendimentos Futuros Previstos",
    averageYields: "Rendimentos Médios",
    yieldTrendsGraph: "Gráfico de Tendências de Rendimento",
    step1: "Passo 1",
    step2: "Passo 2",
    step3: "Passo 3",
    step4: "Passo 4",
    satelliteMapView: "Vista do Mapa de Satélite",
    selectYourFarm: "Selecione sua fazenda no menu suspenso (se já estiver registrada).",
    selectCropType: "Selecione um tipo de cultura:",
    clickGenerateReport: "Clique em 'Gerar Relatório' para visualizar seu relatório de previsão de rendimento.",
    howToGenerateReport: "Como Gerar um Relatório?",
    howToInterpretReport: "Como Interpretar o Relatório?",
    tip: "Dica",

    disclaimer: "Aviso",
    disclaimer1: "É impossível prever com precisão o tempo para uma temporada inteira. Por exemplo, granizo ou inundações podem ocorrer a qualquer momento, o que pode impactar significativamente as previsões de rendimento.",
    disclaimer2: "Os rendimentos dependem fortemente das práticas de manejo do agricultor. Por exemplo, a aplicação oportuna de pesticidas ou a irrigação adequada podem afetar muito o rendimento final.",
    disclaimer3: "Existem outros fatores que podem contribuir para erros significativos nas previsões de rendimento por IA.",
    startYear: "Ano Inicial",
    endYear: "Ano Final",
    back: "Voltar",
    deleteReport: "Excluir Relatório",
    confirmDeleteReport: "Tem certeza de que deseja excluir este relatório de previsão de rendimento? Esta ação não pode ser desfeita e todos os dados associados serão removidos permanentemente.",
    deleteConfirmation: "Confirmação de Exclusão",
    download: "Baixar",
    report: "Relatório",
    dateOfReport: "Data do Relatório",
    farm: "Fazenda",
    location: "Localização",
    zone: "Zona",
    crop: "Cultura",
    farmers: "Agricultores",
    yieldPerAcre: "Rendimento/Acre",
    yieldPerHectare: "Rendimento/Hectare",
    predictionModel: "Modelo de Previsão",
    accuracy: "Precisão (R²)",
    confidence: "Confiança",
    producer: "Produtor",
    reportDeletedSuccessfully: "Relatório excluído com sucesso",
    failedToDeleteReport: "Falha ao excluir o relatório",
    enterHere: "Inserir aqui",
    hectares: "hectares",
    whatIsYieldReportTitle: "O que é um Relatório de Previsão de Rendimento?",
    yieldReportDescription: "O Relatório de Previsão de Rendimento ajuda você a estimar os rendimentos das culturas da sua fazenda usando dados históricos, dados de satélite e modelos preditivos baseados em IA. O relatório fornece uma estimativa de quanto você pode colher no ano atual e nos próximos. O relatório oferece insights sobre rendimentos reais, rendimentos futuros previstos e rendimentos médios, permitindo otimizar suas operações agrícolas e planejar com antecedência.",
    creatingYourReportEasy: "Criar seu relatório é fácil:",
    selectYourFarmDescription: "O limite aparecerá no mapa. Ou desenhe o limite da sua fazenda (polígono ou ponto) manualmente no mapa se ainda não estiver registrada. Você também pode pesquisar digitando Latitude e Longitude para ampliar uma localização.",
    selectCropTypeDescription: "Escolha a cultura que deseja analisar no menu suspenso.",
    clickGenerateReportDescription: "para visualizar seu relatório de previsão de rendimento.",
    interpretReportIntro: "Após gerar o relatório, você verá previsões de rendimento para o ano atual e o próximo. Um gráfico exibe as tendências de rendimento da sua fazenda com três linhas:",
    blueLineActualYields: "Linha Azul (Rendimentos Reais):",
    blueLineDescription: "Representa os resultados reais das colheitas de safras anteriores da sua fazenda. Isso ajuda a entender as tendências de desempenho passadas ao longo do tempo.",
    redLinePredictedYields: "Linha Vermelha (Rendimentos Futuros Previstos):",
    redLineDescription: "Exibe previsões baseadas em IA para os próximos rendimentos. Fornece uma estimativa do que você pode esperar (quanto pode colher) com base em dados e tendências atuais.",
    brownLineAverageYields: "Linha Marrom (Rendimentos Médios):",
    brownLineDescription: "Indica o rendimento médio de todos os dados disponíveis da fazenda. Esta linha serve como referência para ajudá-lo a comparar rendimentos históricos e previstos com a tendência geral.",
    highPredictedYieldsLabel: "Rendimentos previstos altos",
    highPredictedYieldsDescription: "sugerem que as práticas atuais são eficazes. Mantenha suas estratégias e replique-as em outras áreas da sua fazenda.",
    lowPredictedYieldsLabel: "Rendimentos previstos baixos",
    lowPredictedYieldsDescription: "podem indicar áreas de melhoria, como cronogramas de plantio, saúde do solo, uso de fertilizantes, irrigação, manejo de pragas, estresse hídrico ou deficiências de nutrientes, etc. Investigue e resolva esses problemas precocemente para evitar mais perdas de rendimento.",
    tipDescription: "Você pode salvar, baixar ou excluir seus relatórios para referência futura.",
    validationError: "Erro de Validação",
    pleaseSelectCrop: "Por favor, selecione uma cultura",
    pleaseEnterLatLng: "Por favor, insira a latitude e longitude ou selecione um ponto no mapa",
    pleaseDrawGeofence: "Por favor, desenhe uma geocerca no mapa ou carregue um arquivo GeoJSON",
    invalidGeojsonFile: "Arquivo GeoJSON inválido",
    invalidGeojsonFileDescription: "Certifique-se de que o arquivo está em um formato GeoJSON válido.",
    errorReadingFile: "Erro ao ler o arquivo",
    failedToReadGeojson: "Falha ao ler o arquivo GeoJSON. Por favor, tente novamente.",
    yieldReportGeneratedSuccessfully: "Relatório de previsão de rendimento gerado com sucesso",
    failedToGenerateReport: "Falha ao gerar o relatório. Por favor, tente novamente.",
    farmAndFarmId: "Fazenda e ID da Fazenda",
    producerName: "Nome do Produtor",
    failedToLoadReport: "Falha ao carregar o relatório de previsão de rendimento",
    reportDataNotLoaded: "Os dados do relatório não foram carregados. Por favor, aguarde e tente novamente.",
    pdfGeneratedSuccessfully: "PDF gerado com sucesso",
    failedToGeneratePdf: "Falha ao gerar o PDF. Por favor, tente novamente.",
    editMap: "Editar Mapa",
    editMapDescription: "A funcionalidade de edição do mapa será implementada aqui",
    noForecastDataAvailable: "Nenhum dado de previsão disponível",
    noGraphImageAvailable: "Nenhuma imagem de gráfico disponível",
// Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "Painel de Relatórios de IA",
    aiReports: "Relatórios de IA",
    dashboardGuide: "Guia do painel",
    aiReportBuilders: "Geradores de relatórios de IA",
    aiInsightsAndAnalytics: "Insights e análises de IA",
    reportTypeDistribution: "Distribuição por tipo de relatório",
    reportType: "Tipo de relatório",
    reportsGenerated: "Relatórios gerados",
    recentAiReports: "Relatórios de IA recentes",
    vegetationVigorAnalysis: "Análise de vigor vegetativo",
    farmProductivityAnalysis: "Análise de produtividade da fazenda",
    anomaliesDetection: "Detecção de anomalias",
    diseaseDetection: "Detecção de doenças",
    averageVegetationHealth: "Saúde vegetativa média",
    diseaseDetectedThisMonth: "Doenças detectadas este mês",
    anomaliesThisMonth: "Anomalias este mês",
    predictedYieldTrend: "Tendência de rendimento prevista",
    comingSoon: "Em breve",
    reportBuilderComingSoon: "Este gerador de relatórios de IA estará disponível em breve.",
    loadingRecentReports: "Carregando relatórios recentes…",
    noRecentAiReports: "Nenhum relatório de IA recente encontrado.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Fazenda / zona",
    sourcePolygon: "Polígono",
    sourceCircle: "Círculo",
    sourceGeojson: "GeoJSON",
    radiusM: "Raio (m)",
    drawPolygon: "Desenhar polígono",
    drawPolygonHelp: "Clique no mapa para adicionar pontos.",
    drawCircle: "Desenhar círculo",
    drawCircleHelp: "Clique no mapa para definir o centro; defina o raio abaixo ou arraste o círculo para redimensionar.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Análise de produtividade da fazenda",
      listOfReports: "Lista de relatÃ³rios",
      createNewReport: "Criar novo relatÃ³rio",
      backToDashboard: "Voltar ao painel",
      generateReport: "Gerar relatÃ³rio",
      cancel: "Cancelar",
      back: "Voltar",
      deleteReport: "Excluir relatÃ³rio",
      downloadReport: "Baixar relatÃ³rio",
      aiReportGuide: "Guia do relatÃ³rio de IA",
      viewGuide: "Ver guia",
      howToUseReport: "Como usar o relatório?",
      search: "Pesquisar",
      reportId: "ID do relatÃ³rio",
      farmAndFarmId: "Fazenda e ID da fazenda",
      producerName: "Nome do produtor",
      dateOfReport: "Data do relatÃ³rio",
      status: "Status",
      statusCompleted: "ConcluÃ­do",
      statusGenerating: "Gerando",
      statusFailed: "Falhou",
      location: "LocalizaÃ§Ã£o",
      farm: "Fazenda",
      zone: "Zona",
      actions: "AÃ§Ãµes",
      view: "Ver",
      delete: "Excluir",
      selectFarmGeofence: "Selecionar geocerca da fazenda",
      selectFarmGeofenceHelp: "Selecione uma fazenda registrada, desenhe o limite no mapa ou carregue um arquivo GeoJSON.",
      selectFarmZone: "Selecionar fazenda / zona",
      sourceFarmZone: "Fazenda / zona",
      sourcePolygon: "PolÃ­gono",
      sourceCircle: "CÃ­rculo",
      sourceGeojson: "GeoJSON",
      radiusM: "Raio (m)",
      select: "Selecionar",
      uploadGeojsonFile: "Enviar arquivo GeoJSON",
      uploadGeojsonHelp: "Selecione um arquivo GeoJSON com sua geocerca e envie. Apenas uma geocerca serÃ¡ enviada por vez, mesmo que o arquivo tenha vÃ¡rias.",
      selectAFile: "Selecionar um arquivo",
      drawPolygon: "Desenhar polÃ­gono",
      drawPolygonHelp: "Clique no mapa para adicionar pontos.",
      drawCircle: "Desenhar cÃ­rculo",
      drawCircleHelp: "Clique no mapa para definir o centro; defina o raio abaixo ou arraste o cÃ­rculo para redimensionar.",
      estimatedComputeCost: "Custo estimado de computação",
      totalCreditsRequired: "Total de créditos necessários",
      creditsComingSoon: "Sistema de créditos em breve.",
      reportDetails: "Detalhes do relatório",
      generating: "Gerando relatório...",
      generatingHelp: "Seu relatório está sendo gerado. Isso pode levar alguns minutos.",
      failed: "Falha na geração do relatório.",
      reportDescription: "O relatório de zonas de produtividade analisa a produtividade da área da sua fazenda com base no desempenho histórico e nos indicadores de vegetação.",
      disclaimerTitle: "AVISO",
      disclaimer: "Este relatÃ³rio gerado por IA serve como orientaÃ§Ã£o. Para diagnÃ³stico preciso e recomendaÃ§Ãµes personalizadas, consulte um agrÃ´nomo ou especialista agrÃ­cola qualificado.",
      zoneLabels: {
        "Lowest Productivity Zones": "Zonas de menor produtividade",
        "Low Productivity Zones": "Zonas de baixa produtividade",
        "Moderate Productivity Zones": "Zonas de produtividade moderada",
        "High Productivity Zones": "Zonas de alta produtividade",
        "Highest Productivity Zones": "Zonas de maior produtividade",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Áreas com o pior desempenho das culturas que exigem atenção ou intervenção imediata.",
        "Low Productivity Zones": "Áreas com desempenho abaixo da média que precisam de melhorias.",
        "Moderate Productivity Zones": "Áreas com desempenho moderado que podem precisar de alguns ajustes.",
        "High Productivity Zones": "Áreas com desempenho acima da média e bom potencial de rendimento.",
        "Highest Productivity Zones": "Áreas com desempenho ideal e o maior potencial de rendimento.",
      },
      feedback: "Feedback",
      doYouAgree: "Você concorda com a previsão?",
      agree: "Concordo",
      disagree: "Discordo",
      agreedWithPrediction: "Concordou com a previsão",
      disagreedWithPrediction: "Discordou da previsão",
      disagreeHelp: "Se você não concorda com este resultado, forneça seu feedback",
      addFeedback: "Adicionar feedback",
      feedbackPlaceholder: "Digite aqui",
      attachmentsOptional: "Anexos (opcional)",
      attachments: "Anexos",
      download: "Baixar",
      attachmentsHelp: "Arraste e solte imagens ou vÃ­deos aqui, ou navegue pelos arquivos. Formatos suportados: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecione arquivos para enviar os dados",
      orDragAndDrop: "ou arraste e solte aqui",
      submit: "Enviar",
      feedbackSubmitted: "Feedback enviado com sucesso.",
      feedbackAlreadySubmitted: "O feedback jÃ¡ foi enviado para este relatÃ³rio.",
      guideTitle: "Guia de zonas de produtividade",
      guideStep: "Etapa {current} de {total}",
      next: "PrÃ³ximo",
      close: "Fechar",
      guideStep1Title: "O que é o relatório de zonas de produtividade?",
      guideStep1Body: "O relatório de zonas de produtividade analisa a produtividade das áreas dentro da sua zona ou fazenda e as classifica em zonas de baixo, moderado e alto rendimento.",
      guideStep2Title: "Como gerar um relatório?",
      guideStep2Body: "Criar seu relatório é fácil:\n\n1. Selecione sua fazenda no menu suspenso (se registrada) ou desenhe/carregue o limite.\n2. Gere o relatório e aguarde a conclusão da análise.",
      guideStep3Title: "Como interpretar o relatório?",
      guideStep3Body: "Depois de gerado, o relatório mostra um mapa codificado por cores que divide sua fazenda em três zonas de produtividade.",
      guideTip: "Dica:",
      guideTipBody: "Comece pelas zonas laranja — elas precisam das melhorias mais urgentes. Estude as zonas verdes para replicar boas práticas.",
      invalidGeojsonFile: "Arquivo GeoJSON invÃ¡lido",
      invalidGeojsonFileDescription: "O arquivo selecionado nÃ£o Ã© um GeoJSON vÃ¡lido. Verifique e tente novamente.",
      generateFailed: "NÃ£o foi possÃ­vel iniciar a geraÃ§Ã£o do relatÃ³rio. Tente novamente.",
      loadFailed: "NÃ£o foi possÃ­vel carregar o relatÃ³rio. Tente novamente.",
      deleteConfirmTitle: "Excluir relatÃ³rio",
      deleteConfirmMessage: "Tem certeza de que deseja excluir este relatÃ³rio? Esta aÃ§Ã£o nÃ£o pode ser desfeita.",
      deleted: "RelatÃ³rio excluÃ­do com sucesso.",
      uploadFailed: "Falha no envio do arquivo. Tente novamente.",
    },

    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Detecção de anomalias",
      reportComparison: "Comparação de relatórios",
      listOfReports: "Lista de relatÃ³rios",
      createNewReport: "Criar novo relatÃ³rio",
      backToDashboard: "Voltar ao painel",
      generateReport: "Gerar relatÃ³rio",
      cancel: "Cancelar",
      back: "Voltar",
      deleteReport: "Excluir relatÃ³rio",
      downloadReport: "Baixar relatÃ³rio",
      compareReports: "Comparar relatórios",
      aiReportGuide: "Guia do relatÃ³rio de IA",
      search: "Pesquisar",
      reportId: "ID do relatÃ³rio",
      farmAndFarmId: "Fazenda e ID da fazenda",
      producerName: "Nome do produtor",
      dateOfReport: "Data do relatÃ³rio",
      status: "Status",
      statusCompleted: "ConcluÃ­do",
      statusGenerating: "Gerando",
      statusPartial: "Parcial",
      statusFailed: "Falhou",
      location: "LocalizaÃ§Ã£o",
      farm: "Fazenda",
      zone: "Zona",
      actions: "AÃ§Ãµes",
      view: "Ver",
      delete: "Excluir",
      selectFarmGeofence: "Selecionar geocerca da fazenda",
      selectFarmGeofenceHelp: "Selecione uma fazenda registrada, desenhe o limite no mapa ou carregue um arquivo GeoJSON.",
      selectFarmZone: "Selecionar fazenda / zona",
      sourceFarmZone: "Fazenda / zona",
      sourcePolygon: "PolÃ­gono",
      sourceCircle: "CÃ­rculo",
      sourceGeojson: "GeoJSON",
      radiusM: "Raio (m)",
      select: "Selecionar",
      uploadGeojsonFile: "Enviar arquivo GeoJSON",
      uploadGeojsonHelp: "Selecione um arquivo GeoJSON com sua geocerca e envie. Apenas uma geocerca serÃ¡ enviada por vez, mesmo que o arquivo tenha vÃ¡rias.",
      selectAFile: "Selecionar um arquivo",
      drawPolygon: "Desenhar polÃ­gono",
      drawPolygonHelp: "Clique no mapa para adicionar pontos.",
      drawCircle: "Desenhar cÃ­rculo",
      drawCircleHelp: "Clique no mapa para definir o centro; defina o raio abaixo ou arraste o cÃ­rculo para redimensionar.",
      detectAnomalies: "Detectar anomalias",
      detectAnomaliesHelp: "Após desenhar ou carregar uma geocerca, selecione a data de interesse para detectar anomalias.",
      startDate: "Data de início",
      fetchingDates: "Buscando datas disponíveis...",
      noAvailableDates: "Não há datas de satélite disponíveis para esta área.",
      selectDateToGenerate: "Selecione uma data disponível e depois gere o relatório.",
      numberOfHistoricalReports: "Número de relatórios históricos",
      historicalReportsPlaceholder: "Digite aqui",
      historicalReportsNote: "Aumentar este número consumirá créditos de IA adicionais para cada imagem histórica solicitada.",
      estimatedComputeCost: "Custo estimado de computação",
      totalCreditsRequired: "Total de créditos necessários",
      creditsComingSoon: "Sistema de créditos em breve.",
      selectDate: "Selecionar data",
      reportDetails: "Detalhes do relatório",
      closestImageNote: "Imagens de satélite para {requested} não estavam disponíveis. Usamos a imagem disponível mais próxima.",
      generating: "Gerando relatório...",
      generatingHelp: "Seu relatório está sendo gerado. Isso pode levar alguns minutos.",
      partialWarning: "Algumas datas não puderam ser geradas para este relatório.",
      failed: "Falha na geração do relatório.",
      disclaimerTitle: "AVISO",
      disclaimer: "Este relatÃ³rio gerado por IA serve como orientaÃ§Ã£o. Para diagnÃ³stico preciso e recomendaÃ§Ãµes personalizadas, consulte um agrÃ´nomo ou especialista agrÃ­cola qualificado.",
      greenAreas: "Áreas verdes",
      greenAreasDesc: "O vigor vegetativo atual supera a média histórica",
      yellowAreas: "Áreas amarelas",
      yellowAreasDesc: "O vigor vegetativo atual está de acordo com a média histórica",
      redAreas: "Áreas vermelhas",
      redAreasDesc: "Áreas com baixo desempenho das culturas que exigem atenção ou intervenção imediata.",
      underperforming: "Desempenho abaixo",
      outperforming: "Desempenho acima",
      imageComparison: "Comparação de relatórios",
      sideComparison: "Comparação lado a lado",
      sliderComparison: "Comparação com controle deslizante",
      transparencyComparison: "Comparação de transparência",
      transparencySlider: "Controle de transparência",
      notGeneratedPrompt: "Este relatório ainda não foi gerado para a data selecionada. Gerar agora?",
      generateNow: "Gerar agora",
      feedback: "Feedback",
      doYouAgree: "Você concorda com a previsão?",
      agree: "Concordo",
      disagree: "Discordo",
      agreedWithPrediction: "Concordou com a previsão",
      disagreedWithPrediction: "Discordou da previsão",
      disagreeHelp: "Se você não concorda com este resultado, forneça seu feedback",
      addFeedback: "Adicionar feedback",
      feedbackPlaceholder: "Digite aqui",
      attachmentsOptional: "Anexos (opcional)",
      attachments: "Anexos",
      download: "Baixar",
      attachmentsHelp: "Arraste e solte imagens ou vÃ­deos aqui, ou navegue pelos arquivos. Formatos suportados: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecione arquivos para enviar os dados",
      orDragAndDrop: "ou arraste e solte aqui",
      submit: "Enviar",
      feedbackSubmitted: "Feedback enviado com sucesso.",
      feedbackAlreadySubmitted: "O feedback jÃ¡ foi enviado para este relatÃ³rio.",
      guideTitle: "Guia de detecção de anomalias",
      guideStep: "Etapa {current} de {total}",
      next: "PrÃ³ximo",
      close: "Fechar",
      guideStep1Title: "O que é detecção de anomalias?",
      guideStep1Body: "A detecção de anomalias compara o desempenho vegetativo atual do seu campo com a média histórica para identificar áreas com desempenho acima ou abaixo do esperado.",
      guideStep2Title: "Como gerar um relatório?",
      guideStep2Body: "Criar seu relatório é fácil:\n\n1. Selecione sua fazenda no menu suspenso (se já registrada) ou desenhe/carregue o limite.\n2. Escolha uma data disponível e gere o relatório.",
      guideStep3Title: "Como interpretar o relatório?",
      guideStep3Body: "Depois de gerado, o relatório mostra um mapa de calor com cores baseado na comparação do vigor atual com o histórico.",
      guideTip: "Dica:",
      guideTipBody: "Comparação de datas: o relatório fornece mapas de calor para várias datas, permitindo acompanhar mudanças ao longo do tempo.",
      invalidGeojsonFile: "Arquivo GeoJSON invÃ¡lido",
      invalidGeojsonFileDescription: "O arquivo selecionado nÃ£o Ã© um GeoJSON vÃ¡lido. Verifique e tente novamente.",
      geofenceRequired: "Selecione uma fazenda/zona, desenhe uma geocerca ou carregue um GeoJSON.",
      dateRequired: "Selecione uma data disponível.",
      generateFailed: "NÃ£o foi possÃ­vel iniciar a geraÃ§Ã£o do relatÃ³rio. Tente novamente.",
      loadFailed: "NÃ£o foi possÃ­vel carregar o relatÃ³rio. Tente novamente.",
      datesFailed: "Não foi possível obter as datas disponíveis. Tente novamente.",
      deleteConfirmTitle: "Excluir relatÃ³rio",
      deleteConfirmMessage: "Tem certeza de que deseja excluir este relatÃ³rio? Esta aÃ§Ã£o nÃ£o pode ser desfeita.",
      deleted: "RelatÃ³rio excluÃ­do com sucesso.",
      uploadFailed: "Falha no envio do arquivo. Tente novamente.",
    },

        yieldPredictionDesign: {
      disclaimerTitle: "AVISO",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)

      feedback: "Feedback",
      doYouAgree: "Você concorda com a previsão?",
      agree: "Concordo",
      disagree: "Discordo",
      agreedWithPrediction: "Concordou com a previsão",
      disagreedWithPrediction: "Discordou da previsão",
      disagreeHelp: "Se você não concorda com este resultado, forneça seu feedback",
      addFeedback: "Adicionar feedback",
      feedbackPlaceholder: "Digite aqui",
      attachmentsOptional: "Anexos (opcional)",
      attachments: "Anexos",
      download: "Baixar",
      attachmentsHelp: "Arraste e solte imagens ou vídeos aqui, ou navegue pelos arquivos. Formatos suportados: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecione arquivos para enviar os dados",
      orDragAndDrop: "ou arraste e solte aqui",
      submit: "Enviar",
      feedbackSubmitted: "Feedback enviado com sucesso.",
      feedbackAlreadySubmitted: "O feedback já foi enviado para este relatório.",
      uploadFailed: "Falha no envio do arquivo. Tente novamente.",
    },

landSuitabilityDesign: {
      reportDetails: "Detalhes do relatório",
      greenAreas: "Áreas verdes",
      greenAreasDesc: "Áreas classificadas como altamente adequadas para a cultura selecionada",
      yellowAreas: "Áreas amarelas",
      yellowAreasDesc: "Áreas com adequação moderada que podem precisar de atenção",
      redAreas: "Áreas vermelhas",
      redAreasDesc: "Áreas classificadas como inadequadas e que provavelmente precisam de intervenção",
      underperforming: "Desempenho abaixo",
      outperforming: "Desempenho acima",
      feedback: "Feedback",
      doYouAgree: "Você concorda com a previsão?",
      agree: "Concordo",
      disagree: "Discordo",
      agreedWithPrediction: "Concordou com a previsão",
      disagreedWithPrediction: "Discordou da previsão",
      disagreeHelp: "Se você não concorda com este resultado, forneça seu feedback",
      addFeedback: "Adicionar feedback",
      feedbackPlaceholder: "Digite aqui",
      attachmentsOptional: "Anexos (opcional)",
      attachments: "Anexos",
      download: "Baixar",
      attachmentsHelp: "Arraste e solte imagens ou vídeos aqui, ou navegue pelos arquivos. Formatos suportados: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecione arquivos para enviar os dados",
      orDragAndDrop: "ou arraste e solte aqui",
      submit: "Enviar",
      feedbackSubmitted: "Feedback enviado com sucesso.",
      feedbackAlreadySubmitted: "O feedback já foi enviado para este relatório.",
      uploadFailed: "Falha no envio do arquivo. Tente novamente.",
    },
    cropProgression: {
      title: "Análise do vigor da vegetação",
      listOfReports: "Lista de relatórios",
      createNewReport: "Criar novo relatório",
      backToDashboard: "Voltar ao painel",
      generateReport: "Gerar relatório",
      cancel: "Cancelar",
      back: "Voltar",
      deleteReport: "Excluir relatório",
      downloadReport: "Baixar relatório",
      compareImages: "Comparar imagens",
      aiReportGuide: "Guia do relatório de IA",
      search: "Pesquisar",
      reportId: "ID do relatório",
      farmAndFarmId: "Fazenda e ID da fazenda",
      producerName: "Nome do produtor",
      dateOfReport: "Data do relatório",
      selectedDate: "Data do reporte",
      status: "Status",
      statusCompleted: "Concluído",
      statusGenerating: "Gerando",
      statusPartial: "Parcial",
      statusFailed: "Falhou",
      location: "Localização",
      farm: "Fazenda",
      zone: "Zona",
      actions: "Ações",
      view: "Ver",
      delete: "Excluir",
      selectFarmGeofence: "Selecionar geocerca da fazenda",
      selectFarmGeofenceHelp: "Selecione uma fazenda registrada, desenhe o limite no mapa ou carregue um GeoJSON para começar a analisar sua área.",
      point: "Ponto",
      geofence: "Geocerca",
      selectFarmZone: "Selecionar fazenda / zona",
      sourceFarmZone: "Fazenda / zona",
      sourcePolygon: "Polígono",
      sourceCircle: "Círculo",
      sourceGeojson: "GeoJSON",
      mapView: "Vista do mapa",
      latitude: "Latitude",
      longitude: "Longitude",
      radiusKm: "Raio (km)",
      radiusM: "Raio (m)",
      enterHere: "Digite aqui",
      select: "Selecionar",
      uploadGeojsonFile: "Enviar arquivo GeoJSON",
      uploadGeojsonHelp: "Selecione um arquivo GeoJSON com sua geocerca e envie. Apenas uma geocerca será enviada por vez, mesmo que o arquivo tenha várias.",
      selectAFile: "Selecionar um arquivo",
      drawPolygon: "Desenhar polígono",
      drawPolygonHelp: "Clique no mapa para adicionar pontos.",
      drawCircle: "Desenhar círculo",
      drawCircleHelp: "Clique no mapa para definir o centro; defina o raio abaixo ou arraste o círculo para redimensionar.",
      clearDrawing: "Limpar",
      searchLocation: "Pesquisar localização",
      closePolygonHint: "Clique no primeiro ponto para fechar a área",
      unnamedFarm: "Fazenda #{id}",
      unnamedZone: "Zona #{id}",
      selectDate: "Selecionar data",
      availableDates: "Datas disponíveis",
      fetchingDates: "Buscando datas disponíveis...",
      noAvailableDates: "Não há datas de satélite disponíveis para esta área.",
      selectDateToGenerate: "Selecione uma data disponível e depois gere o relatório.",
      estimatedComputeCost: "Custo estimado de computação",
      totalCreditsRequired: "Total de créditos necessários",
      creditsAvailable: "Créditos disponíveis",
      creditsSufficient: "Créditos suficientes para geração do relatório de IA",
      reportType: "Tipo de relatório",
      selectReportType: "Selecionar tipo de relatório",
      chooseIndexHelp: "Escolha um índice de satélite para analisar o crescimento, a umidade ou os nutrientes da cultura ao longo do tempo.",
      scale: "Escala",
      generating: "Gerando relatório...",
      generatingHelp: "Seu relatório está sendo gerado. Isso pode levar alguns minutos.",
      partialWarning: "Alguns índices não puderam ser gerados para esta data.",
      failed: "Falha na geração do relatório.",
      valuesCloseToOne: "Valores próximos de 1 indicam vegetação mais saudável",
      disclaimerTitle: "AVISO",
      disclaimer: "Este relatório gerado por IA serve como orientação. Para diagnóstico preciso e recomendações personalizadas, consulte um agrônomo ou especialista agrícola qualificado.",
      indexNDVI: "Saúde da cultura (NDVI)",
      indexMSAVI: "Crescimento vegetativo inicial (MSAVI)",
      indexLSWI: "Conteúdo de umidade (LSWI)",
      indexRECI: "Estimativa do nível de nutrientes (RECI)",
      indexNDRE: "Verdor e densidade do dossel (NDRE)",
      reportComparison: "Comparação de relatórios de vigor da vegetação",
      imageComparison: "Comparação de imagens",
      sideComparison: "Comparação lado a lado",
      sliderComparison: "Comparação com controle deslizante",
      transparencyComparison: "Comparação de transparência",
      transparencySlider: "Controle de transparência",
      notGeneratedPrompt: "Este relatório ainda não foi gerado para a data selecionada. Gerar agora?",
      generateNow: "Gerar agora",
      feedback: "Feedback",
      doYouAgree: "Você concorda com a previsão?",
      agree: "Concordo",
      disagree: "Discordo",
      agreedWithPrediction: "Concordou com a previsão",
      disagreedWithPrediction: "Discordou da previsão",
      disagreeHelp: "Se você não concorda com este resultado, forneça seu feedback",
      addFeedback: "Adicionar feedback",
      feedbackPlaceholder: "Digite aqui",
      attachmentsOptional: "Anexos (opcional)",
      attachments: "Anexos",
      download: "Baixar",
      attachmentsHelp: "Arraste e solte imagens ou vídeos aqui, ou navegue pelos arquivos. Formatos suportados: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecione arquivos para enviar os dados",
      orDragAndDrop: "ou arraste e solte aqui",
      submit: "Enviar",
      feedbackSubmitted: "Feedback enviado com sucesso.",
      feedbackAlreadySubmitted: "O feedback já foi enviado para este relatório.",
      guideTitle: "Guia de análise do vigor da vegetação",
      guideStep: "Etapa {current} de {total}",
      next: "Próximo",
      close: "Fechar",
      guideStep1Title: "O que é o relatório de análise do vigor da vegetação?",
      guideStep1Body: "Esta análise ajuda a identificar áreas da fazenda com baixo vigor vegetativo para agir a tempo. O relatório usa imagens de satélite para mostrar a saúde das culturas em um momento específico.\n\nO mapa de calor mostra quais partes da fazenda podem precisar de atenção. Comparando imagens de datas diferentes, você acompanha se as culturas melhoram ou pioram.",
      guideStep2Title: "Como gerar um relatório?",
      guideStep2Body: "Criar o relatório é fácil:\n\n1. Selecione a fazenda no menu (se já registrada). O limite aparecerá no mapa. Ou desenhe o limite manualmente se ainda não estiver registrada.\n2. Escolha uma data: a data para a qual deseja ver os dados de vigor.\n3. Clique em \"Gerar relatório\" para ver a análise.",
      guideStep3Title: "Como interpretar o relatório?",
      guideStep3Body: "Após a geração, você verá um mapa de calor da fazenda com verde, amarelo e vermelho.\n\nVerde = Alto vigor vegetativo\nAmarelo/Vermelho = Menor vigor → pode precisar de atenção\n\nBaixo vigor pode ser causado por colheita, solo pobre, pragas ou clima recente.",
      guideTip: "Dica:",
      guideTipBody: "Use o seletor de datas abaixo do mapa de calor para ver vários relatórios e acompanhar mudanças na saúde da cultura. Você pode salvar, baixar ou excluir relatórios a qualquer momento.",
      additionalReportTypes: "Tipos de relatório adicionais disponíveis:",
      invalidGeojsonFile: "Arquivo GeoJSON inválido",
      invalidGeojsonFileDescription: "O arquivo selecionado não é um GeoJSON válido. Verifique e tente novamente.",
      geofenceRequired: "Selecione uma fazenda/zona, desenhe uma geocerca ou carregue um GeoJSON.",
      dateRequired: "Selecione uma data disponível.",
      generateFailed: "Não foi possível iniciar a geração do relatório. Tente novamente.",
      loadFailed: "Não foi possível carregar o relatório. Tente novamente.",
      datesFailed: "Não foi possível buscar as datas disponíveis. Tente novamente.",
      deleteConfirmTitle: "Excluir relatório",
      deleteConfirmMessage: "Tem certeza de que deseja excluir este relatório? Esta ação não pode ser desfeita.",
      deleted: "Relatório excluído com sucesso.",
      uploadFailed: "Falha no envio do arquivo. Tente novamente.",
    },
    aiClient: {
      credits: "Créditos",
      cancel: "Cancelar",
      save: "Salvar",
      back: "Voltar",
      close: "Fechar",
      search: "Pesquisar",
      makeSelection: "Faça uma seleção",
      errorTitle: "Erro",
      successTitle: "Sucesso",
      loadFailed: "Não foi possível carregar os dados. Tente novamente.",
      saveFailed: "Não foi possível salvar. Tente novamente.",
      saved: "Configurações salvas com sucesso.",
      rt_vegetation_vigor: "Vigor da vegetação",
      rt_farm_productivity: "Produtividade da fazenda",
      rt_anomaly_detection: "Detecção de anomalias",
      rt_yield_prediction: "Previsão de rendimento",
      rt_disease_detection: "Detecção de doenças",
      rt_land_suitability: "Aptidão da terra",
      dashTitle: "Painel de relatórios de IA",
      dashGuide: "Guia do painel",
      builders: "Geradores de relatórios de IA",
      distributionTitle: "Distribuição por tipo de relatório",
      colReportType: "Tipo de relatório",
      colReportsGenerated: "Relatórios gerados",
      recentTitle: "Relatórios de IA recentes",
      noRecent: "Nenhum relatório gerado ainda.",
      noDistribution: "Ainda não há atividade de relatórios.",
      na: "N/D",
      bVegetationVigor: "Análise do vigor da vegetação",
      bFarmProductivity: "Análise de produtividade da fazenda",
      bAnomalies: "Detecção de anomalias",
      bYield: "Previsão de rendimento",
      bDisease: "Detecção de doenças",
      bLand: "Aptidão da terra",
      insightsTitle: "Insights e análises de IA",
      iVegHealth: "Saúde média da vegetação",
      iDisease: "Doenças detectadas este mês",
      iAnomalies: "Anomalias este mês",
      iYieldTrend: "Tendência de rendimento prevista",
      creditsAvailableLabel: "Disponíveis",
      totalCredits: "Créditos totais:",
      creditsUsedLabel: "Créditos usados:",
      topUp: "Recarregar créditos",
      topUpInfo: "Entre em contato com o administrador para recarregar créditos.",
      creditsHistory: "Histórico de créditos",
      manageBtn: "Gerenciar relatórios de IA e créditos",
      manageTitle: "Gerenciar relatórios de IA e créditos",
      usageLogBtn: "Registro de uso de créditos",
      cardAvailable: "Créditos disponíveis",
      cardTotal: "Créditos totais",
      cardUsed: "Créditos usados",
      refreshesOn: "Renova em",
      assignedOn: "Atribuído em",
      distBudgetTitle: "Distribuição e orçamento de relatórios de IA",
      distBudgetHelp: "Configure o acesso aos relatórios de IA para suas uniões, fábricas e agricultores. Aloque orçamentos de créditos específicos a cada nível para gerenciar o consumo de recursos da cooperativa com eficiência.",
      group_cooperative: "Cooperativa",
      group_buying_station: "Estação de compra",
      group_farmer: "Agricultor",
      monthlyCredits: "Créditos mensais",
      aiReports: "Relatórios de IA",
      enabled: "Ativado",
      disabled: "Desativado",
      overAllocation: "As alocações do grupo excedem o orçamento de créditos da cooperativa.",
      usageLogTitle: "Registro de uso de créditos",
      filterCooperative: "Cooperativa",
      filterReport: "Relatório de IA",
      colDateTime: "Data e hora",
      colEntity: "Entidade",
      colAiReport: "Relatório de IA",
      colCreditsUsed: "Créditos usados",
      colBalance: "Saldo",
      historyTitle: "Histórico de créditos",
      historyDesc: "Uma visão geral das alocações de créditos versus o consumo desta cooperativa. Use este resumo para acompanhar tendências mensais de uso e ciclos de faturamento.",
      coopLabel: "Cooperativa",
      colMonth: "Mês",
      colCreditsAssigned: "Créditos atribuídos",
      colClosingBalance: "Saldo de fechamento",
      noHistory: "Ainda não há histórico de créditos.",
      guideTitle: "Guia do painel de relatórios de IA da Dimitra",
      guideStep: "Etapa",
      guideOf: "de",
      guideClose: "Fechar",
      guideSkip: "Pular",
      guideNext: "Próximo",
      guideBack: "Voltar",
      guideDone: "Fechar",
      g1Title: "Visão geral do painel",
      g1Intro: "Bem-vindo ao seu hub de insights de IA. Este guia ajudará você a interpretar o mapa, gerenciar seus créditos e usar os modelos de IA.",
      g1Points: [
        "Entenda os insights do mapa: Use os filtros do mapa para ver províncias e regiões específicas. O mapa de calor oferece uma visão imediata codificada por cores do desempenho das fazendas na cooperativa, com chaves para indicadores Alto/Médio/Baixo.",
        "Monitore os créditos: Seus créditos disponíveis atuais são mostrados no canto superior direito. Certifique-se de ter saldo suficiente antes de gerar relatórios grandes.",
      ],
      g2Title: "Como entender os relatórios de IA",
      g2Intro: "Seu painel oferece acesso a modelos de IA especializados. Cada relatório analisa aspectos diferentes dos seus dados agrícolas.",
      g2Points: [
        "Vigor da vegetação: Avalie a saúde geral da cultura e identifique áreas que precisam de atenção.",
        "Produtividade da fazenda: Analise tendências históricas de produtividade para otimizar o potencial de rendimento.",
        "Detecção de anomalias: Identifique padrões irregulares no campo que possam indicar estresse ou ameaças externas.",
        "Previsão de rendimento: Preveja resultados de colheita com base nos dados de crescimento atuais.",
        "Detecção de doenças: Use imagens de plantas para identificar doenças específicas imediatamente.",
      ],
      g3Title: "Como os créditos funcionam",
      g3Intro: "A Dimitra usa um sistema baseado em créditos para gerenciar o consumo de recursos de IA. Os créditos funcionam como moeda para gerar relatórios.",
      g3Points: [
        "Alocação: Sua cooperativa recebe um saldo mensal do administrador.",
        "Consumo: Sempre que você gera um relatório, os créditos são deduzidos do saldo disponível.",
        "Visibilidade: Você pode acompanhar cada dedução no seu livro de créditos dedicado.",
      ],
      g4Title: "Monitoramento de uso e histórico de créditos",
      g4Intro: "Mantenha o controle do orçamento acompanhando de perto o histórico de créditos.",
      g4Points: [
        "Saldo disponível: Sempre visível no cartão superior direito. Preste atenção à data de renovação para saber quando chega a próxima alocação.",
        "Registro de uso: Clique em [Histórico de créditos] para ver um detalhamento de qual relatório foi gerado, quando e por qual entidade (cooperativa, união, fábrica ou agricultor).",
        "Gestão: Se os créditos estiverem acabando, use o botão [Gerenciar relatórios de IA e créditos] para ajustar orçamentos por entidade ou fale com o administrador para uma recarga adicional.",
      ],
    },
  },
}

